import { useDispatch, useSelector } from 'react-redux';
import Component from '../../components/order_history';
import { useEffect } from 'react';
import { RootState } from '../../redux/reducer';
import { handlePurchaseListRequest } from '../../redux/action/product.action';

export default function OrderHistory() {
  const dispatch = useDispatch();
  const { purchase_list } = useSelector(({ product }: RootState) => product);

  useEffect(() => {
    function success() {}
    function failure() {}

    dispatch(handlePurchaseListRequest(success, failure));
  }, []);

  return <Component purchase_list={purchase_list} />;
}
